<template>
    <div>
        <div class="upload-ad second border-radius-top p-4 d-flex flex-md-row justify-content-between">
            <vue-dropzone
                ref="vueDropzone"
                id="dropzone"
                :options="dropzoneOptions"
                :useCustomSlot=true
                @vdropzone-file-added="fileAdded"
                @vdropzone-thumbnail="thumbnailCreated">
                <div class="dropzone-custom-content d-flex align-self-center">
                    <div class="flex-fill col-2 d-inline-flex flex-column justify-content-center align-self-center align-items-center">
                        <h3 class="dropzone-custom-title font-weight-bold fs-16">Drag, drop or click to upload your advert</h3>
                        <div class="subtitle fs-16">624px x 312px</div>
                    </div>
                </div>
            </vue-dropzone>

            <div class="preview-container position-relative flex-fill col-2 d-inline-flex flex-column justify-content-center align-items-center border-radius bg-white ml-md-4 ">
                <div
                    v-if="! file && ! filePreview"
                    class="preview-placeholder text-uppercase d-flex justify-content-center align-self-center align-items-center align-self-center">
                    Your Advert
                </div>
                <div
                    v-else
                    class="preview-file-container">
                    <img
                        :src="filePreview"
                        alt="File Preview"
                        class="preview-file-image border-radius">
                    <div v-if="filePreview" class="text-uppercase fs-12 t-white position-absolute preview-remove mt-1"
                         @click="removeFile">
                        Remove
                    </div>
                </div>
            </div>

        </div>
        <div>
            <div class="container d-flex flex-column flex-sm-row row-cols-2 border-radius-bottom upload-url bg-white row p-4 h-auto">
                <div class="col-12 col-sm-5 d-inline-flex flex-fill flex-column mr-sm-3 pb-3 pb-sm-0 w-100">
                    <label class="ad-label fs-16 mb-1 d-inline-block">
                        Advert URL
                    </label>
                    <input type="text"
                           ref="urlField"
                           v-model="advertUrl"
                           class="input-link fs-16 px-2">
                </div>

                <button v-if="!loading" @click="update"
                        type="submit"
                        class="button-update fs-18 border-radius align-self-stretch flex-fill flex-grow-1 col-5 mh-100 py-2 py-sm-0 bg-orange t-white text-center">
                        Update
                </button>
                <pulse-loader v-if="loading"
                              :loading="true"
                              :color="'#E57722'"
                              class="d-flex justify-content-center align-items-center align-self-stretch flex-fill col-5 mh-100"
                              :size="'20px'">
                </pulse-loader>
            </div>

        </div>
    </div>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import PulseLoader from "vue-spinner/src/PulseLoader";
    import {axiosWeb,axiosApi} from "@/js/axios";

    export default {
        name: 'Dropzone',
        components: {
            vueDropzone: vue2Dropzone,
            PulseLoader,
        },
        data: function () {
            return {
                dropzoneOptions: {
                    autoProcessQueue: false,
                    url: '#',
                    maxFiles: 1,
                    thumbnailWidth: '468',
                    thumbnailHeight: '234',
                    acceptedMimeTypes: 'image/*, application/pdf',
                    previewsContainer: false,
                },
                file: null,
                filePreview: null,
                url: null,
                loading: false,
                errors: []
            }
        },
        computed: {
            userHasAdvert() {
                return this.$root.user.hasOwnProperty('user_advert') &&
                    this.$root.user.user_advert;
            },
            advertImageUrl() {
                return (
                    this.userHasAdvert &&
                    this.$root.user.user_advert.hasOwnProperty('image_url')
                )
                    ? this.$root.user.user_advert.image_url
                    : null;

            },
            advertUrl(){
                return (
                    this.userHasAdvert &&
                    this.$root.user.user_advert.hasOwnProperty('url')
                )
                    ? this.$root.user.user_advert.url
                    : null;
            }
        },
        watch: {
            advertImageUrl: {
                deep: true,
                immediate: true,
                handler(val) {
                    if (val) {
                        this.filePreview = val;
                    }
                }
            },
            advertUrl: {
                deep: true,
                immediate: true,
                handler(val) {
                    if (val) {
                        this.url = val;
                    }
                }
            },

        },
        mounted(){
        },
        methods: {
            fileAdded(file) {
                this.file = file;
            },
            thumbnailCreated(file, dataUrl) {
                this.filePreview = dataUrl;
            },
            removeFile() {
                this.file = null;
                this.filePreview = null;
            },
            update() {
                this.loading = true;
                var formData = new FormData();

                if (this.file) {
                    formData.append("image", this.file);
                }

                if (this.filePreview && !this.file) {
                    formData.append("image_url", this.filePreview);
                }

                formData.append("url", this.$refs.urlField.value);
                const userAdvert = this.$root.user.user_advert;
                if ( userAdvert != null){
                    return axiosWeb.post(`/api/v1/user-a-subscription/${userAdvert.id}`, formData).then(response => {
                        this.loading = false;
                        let toast = Vue.toasted.show("The advert has been updated.", {
                            theme: "toasted-primary",
                            type: 'success',
                            icon: 'done',
                            position: "top-center",
                            duration: 3000,
                            className: 'shadow-modal rounded-lg font-primary p-2',
                        });
                        setTimeout(() => this.errors = false, 4000);
                    }).catch((error) => {
                        this.loading = false;
                        let message = error.message;

                        if (error.response.data.errors.hasOwnProperty('image')) {
                            message = error.response.data.errors.image;
                        } else if (error.response.data.errors.hasOwnProperty('url')) {
                            message = "Url must be a valid web address.";
                        }

                        let toast = Vue.toasted.show(message, {
                            theme: "toasted-primary",
                            type: 'error',
                            icon: 'close',
                            position: "top-center",
                            duration : 3000,
                            className: 'shadow-modal rounded-lg font-primary p-2',
                        });

                        setTimeout(() => this.errors = false, 4000);
                    })
                } else {
                    return axiosWeb.post(`/api/v1/user-a-subscription`, formData).then(response => {
                        this.loading = false;
                        let toast = Vue.toasted.show("The advert has been created.", {
                            theme: "toasted-primary",
                            type: 'success',
                            icon: 'done',
                            position: "top-center",
                            duration: 6000,
                            className: 'shadow-modal rounded-lg font-primary p-2',
                        });
                        setTimeout(() => this.errors = false, 4000);

                    }).catch((error) => {
                        this.loading = false;
                        let message = error.message;

                        if (error.response.data.errors.hasOwnProperty('image')) {
                            message = error.response.data.errors.image;
                        } else if (error.response.data.errors.hasOwnProperty('url')) {
                            message = "Url must be a valid web address.";
                        }

                        let toast = Vue.toasted.show(message, {
                            theme: "toasted-primary",
                            type: 'error',
                            icon: 'close',
                            position: "top-center",
                            duration : 6000,
                            className: 'shadow-modal rounded-lg font-primary p-2',
                        });

                        setTimeout(() => this.errors = false, 4000);
                    })
                }
            }
        }
    }

</script>

<style lang="scss" scoped>
    .upload-ad {
        background: $c-orange-pale;
        box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.03)
    }
    .ad-label{
        cursor: default;
    }
    .border-radius-bottom{
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
    }
    .input-link{
        line-height: 26px;
        border: 1px solid $c-grey;
        height: 48px;
    }
    .flex-fill{
        flex-grow: 1 !important;
        flex-shrink: 1 !important;
        flex-basis: 0 !important;
    }
    label {
        color: $c-navy-blue;
    }
    button[type="submit"] {
        font-family: $f-primary;
    }
    .dropzone{
        display: flex;
        min-height: 202px;
        min-width: 404px;
        max-width: 468px;
        max-height: 213px;
    }
    .dz-message{
        margin: 0 auto;
    }

    .preview-container{
        color:#D0D7D9;
        max-width: 468px;
        max-height: 213px;
        min-height: 213px;
        min-width: 404px;
    }
    .preview-file-container{
        max-width: 468px;
        max-height: 213px;
        min-height: 213px;
        min-width: 404px;
    }

    @media (max-width: 385px){
        .button-update{
            font-size: 13px;
        }
        #dropzone{
            padding: 0;
        }
    }
    @media (max-width: 468px) {
        .dropzone{
            display: flex;

            max-width: 468px;
            max-height: 213px;
        }

        .preview-container{
            max-width: 468px;
            max-height: 213px;

        }
        .preview-file-container{
            max-width: 468px;
            max-height: 213px;

        }
    }

    @media (max-width: 530px){
        .dropzone{
            display: flex;

            max-width: unset;
            max-height: unset;
            min-width: unset;
            min-height: unset;
        }

        .preview-container{
            max-width: unset;
            max-height: unset;
            min-width: unset;
            min-height: unset;
        }
        .preview-file-container{
            max-width: unset;
            max-height: unset;
            min-width: unset;
            min-height: unset;
        }
        .preview-placeholder{
            padding: 32px;
            width: 337px;
            height: 174px;
        }
    }

    @media (max-width: 893px){
        #dropzone{
            margin-bottom: 20px;
            width: 100%;
            justify-content: center;
        }
        .upload-ad {
            flex-direction: column !important;
            align-items: center;
        }
        .preview-container{
            margin-left: 0 !important;
            width: 100%;
        }
    }

    @media (max-width: 1150px){
        .preview-container{
            margin-left: 0;
        }
    }



</style>



// WEBPACK FOOTER //
// resources/js/components/Dropzone.vue